import { tv, VariantProps } from '@/utils/tv'

export const conversionFormVariant = tv({
  slots: {
    base: ['bg-white', 'p-14', 'flex flex-col gap-8'],
    title: ['max-w-sm', 'text-center', 'mx-auto'],
    form: ['grid grid-cols-1 gap-6'],
    send: []
  }
})

export type ConversionFormVariantProps = VariantProps<
  typeof conversionFormVariant
>
